import { LibraryItemTypes } from '../store/enums'

export const LibraryTopFilters = [
  LibraryItemTypes.THIRD_PARTY_COST,
  LibraryItemTypes.DELIVERABLE,
  LibraryItemTypes.COMPONENT,
]
